module.exports = __webpack_public_path__ + "media/guide_en.c874cf5f.mp4";